import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD,
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_BY_ID,
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_DATAENTRY_BY_ID,

    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_DATAENTRY,
    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE,

    ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE,

    ITrialInstitutionItemCustomViewLoadAction,

    ITrialInstitutionItemCustomViewLoadByIdAction,
    ITrialInstitutionItemCustomViewLoadDataEntryByIdAction,
    ITrialInstitutionItemCustomViewLoadFailureAction,
    ITrialInstitutionItemCustomViewLoadSuccessAction,

    ITrialInstitutionItemCustomViewSaveDataEntryAction,
    ITrialInstitutionItemCustomViewSaveAction,
    ITrialInstitutionItemCustomViewSaveSuccessAction,
    ITrialInstitutionItemCustomViewSaveFailureAction,

    ITrialInstitutionItemCustomViewCreateAction,
    ITrialInstitutionItemCustomViewCreateSuccessAction,
    ITrialInstitutionItemCustomViewCreateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure
    

} from "../actions/trialInstitutionItemCustomView";
import { trialInstitutionItemCustomViewsApi } from "../services/trialInstitutionItemCustomViews";

export const
    getTrialInstitutionItemCustomViewsEpic = (action$): Observable<ITrialInstitutionItemCustomViewLoadSuccessAction | ITrialInstitutionItemCustomViewLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD)
            .mergeMap((action: ITrialInstitutionItemCustomViewLoadAction) => {
                return trialInstitutionItemCustomViewsApi
                    .getTrialInstitutionItemCustomViews(action.trialId)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionItemCustomViews, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialInstitutionItemCustomViewByIdEpic = (action$): Observable<ITrialInstitutionItemCustomViewLoadSuccessAction | ITrialInstitutionItemCustomViewLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_BY_ID)
            .mergeMap((action: ITrialInstitutionItemCustomViewLoadByIdAction) => {
                return trialInstitutionItemCustomViewsApi
                    .getTrialInstitutionItemCustomViewById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionItemCustomView, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialInstitutionItemCustomViewDataEntryByIdEpic = (action$): Observable<ITrialInstitutionItemCustomViewLoadSuccessAction | ITrialInstitutionItemCustomViewLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_LOAD_DATAENTRY_BY_ID)
            .mergeMap((action: ITrialInstitutionItemCustomViewLoadDataEntryByIdAction) => {
                return trialInstitutionItemCustomViewsApi
                    .getTrialInstitutionItemCustomViewDataEntryById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionItemCustomView, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialInstitutionItemCustomViewEpic = (action$): Observable<ITrialInstitutionItemCustomViewSaveSuccessAction | ITrialInstitutionItemCustomViewSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE)
            .mergeMap((action: ITrialInstitutionItemCustomViewSaveAction) => {
                return trialInstitutionItemCustomViewsApi
                    .setTrialInstitutionItemCustomView(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }
                        return SaveSuccess(response.trialInstitutionItemCustomView, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    setTrialInstitutionItemCustomViewDataEntryEpic = (action$): Observable<ITrialInstitutionItemCustomViewSaveSuccessAction | ITrialInstitutionItemCustomViewSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_SAVE_DATAENTRY)
            .mergeMap((action: ITrialInstitutionItemCustomViewSaveDataEntryAction) => {
                return trialInstitutionItemCustomViewsApi
                    .setTrialInstitutionItemCustomViewDataEntryById(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }
                        return SaveSuccess(response.trialInstitutionItemCustomView, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialInstitutionItemCustomViewEpic = (action$): Observable<ITrialInstitutionItemCustomViewCreateSuccessAction | ITrialInstitutionItemCustomViewCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONITEMCUSTOMVIEW_CREATE)
            .mergeMap((action: ITrialInstitutionItemCustomViewCreateAction) => {
                return trialInstitutionItemCustomViewsApi
                    .createTrialInstitutionItemCustomView(action.trialId, action.institutionId, action.formTemplateId)
                    .map(response =>
                        CreateSuccess(response.trialInstitutionItemCustomView, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    };